import React, { useEffect, useState, useRef } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { TabView, TabPanel } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import { useNavigate, useOutletContext } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
export default function FormularioEmpleado() {
  const axiosPrivate = useAxiosPrivate();
  const [catalogos, setCatalogos] = useState({});
  const [estados, setEstados] = useState({});
  const [colonias, setColonias] = useState({});
  const [numeroReadOnly, setNumeroReadOnly] = useState(false);
  const { empleadoSeleccionado, selectedNomina } = useOutletContext();
  const [empleadoCreado, setEmpleadoCreado] = useState(null);

  const toast = useRef(null);
  const navigate = useNavigate();

  const { control, setValue, getValues, handleSubmit, reset } = useForm({
    defaultValues: {
      numero: "",
      apellidoPaterno: "",
      apellidoMaterno: "",
      nombre: "",
      idNomina: "",
      fechaNacimiento: null,
      lugarNacimiento: null,
      genero: null,
      fechaIngreso: null,
      curp: "",
      rfc: "",
      nss: "",

      //agrupadores
      horario: 1,
      turno: "1",
      ccto: null,
      departamento: null,
      categoria: 0,
      supervisor: 0,
      jefe: 0,
      tipo: 0,
      puesto: 0,
      nivel: 0,
      seccion: null,
      area: null,
      catINEGI: 3,

      //datos de salario
      gs: 1,
      tipoSalario: null,
      pbd: "",
      sdi: "",
      salarioMensual: "",

      //informacion bancaria
      tipoPago: "",
      idBanco: "",
      cuenta: "",
      numeroTarjeta: "",

      //despensa
      servicioDespensa: "",
      cuentaDespensa: "",
      tarjetaDespensa: "",

      //Domicilio
      direccion: "",
      numCasa: "",
      colonia: "",
      ciudad: "",
      cp: "",
      municipio: "",
      estado: "",
      telefono: "",
      correoElectronico: "",
      estadoCivil: "",
      escolaridad: "",

      //adicionales
      umf: "",
      folioInfonavit: "",

      //
      dirind: 0,
      tipoRegimen: 0,
      tipoContrato: 0,
      MunicipioNacimiento: 0,
    },
  });

  const onSubmit = async (data) => {
    try {
      const res = await axiosPrivate.post("/NOM/empleados", { empleado: data });
      toast.current.show({
        severity: "success",
        summary: "Guardado",
        detail: "Empleado registrado exitosamente",
        life: 3000,
      });
      console.log("Empleado creado:", res.data.empleado);
      setEmpleadoCreado(res.data.empleado);
      //reset();
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Hubo un problema al registrar",
        life: 3000,
      });
    }
  };

  const confirmarGuardado = (data) => {
    confirmDialog({
      message:
        "¿Deseas guardar este empleado en la nomina " +
        selectedNomina.Nomina +
        "?",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí",
      rejectLabel: "No",
      accept: () => onSubmit(data),
    });
  };

  const limpiarFormulario = () => reset();
  useEffect(() => {
    const obtenerFechaNacimientoDesdeCurpORfc = (curp, rfc) => {
      const valor = curp || rfc;

      if (!valor || valor.length < 10) return null;

      const anio = parseInt(valor.substring(4, 6), 10);
      const mes = parseInt(valor.substring(6, 8), 10);
      const dia = parseInt(valor.substring(8, 10), 10);

      if (isNaN(anio) || isNaN(mes) || isNaN(dia)) return null;

      const anioCompleto = anio < 30 ? 2000 + anio : 1900 + anio; // asumiendo años entre 1930 y 2029

      const fecha = new Date(anioCompleto, mes - 1, dia);
      return isNaN(fecha.getTime()) ? null : fecha;
    };
    const mapGenero = (genero) => {
      if (genero === "M") return 1;
      if (genero === "F") return 2;
      return null; // o algún valor por defecto
    };
    const mapPorTexto = (texto, opciones) => {
      if (!texto || !Array.isArray(opciones)) return null;
      const normalizar = (s) => {
  if (!s) return "";
  return s
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

      const textoNormalizado = normalizar(texto);

      const match = opciones.find((opcion) =>
        normalizar(opcion.Descripcion).includes(textoNormalizado)
      );
      return match ? match.numero : null;
    };
    const extraerEstadoDeCURP = (curp) => {
      if (!curp || curp.length < 13) return null;
      return curp.substring(11, 13).toUpperCase(); // posición 11 y 12 (0-based)
    };
    if (empleadoSeleccionado && catalogos) {
      const obtenerNuevoNumero = async () => {
        await handleNuevo(); // tu función async
        setValue("idNomina", selectedNomina.idNomina);
        setValue("nombre", empleadoSeleccionado.nombre);
        setValue("apellidoPaterno", empleadoSeleccionado.apellidoPaterno);
        setValue("apellidoMaterno", empleadoSeleccionado.apellidoMaterno);
        const fechaNacimiento = empleadoSeleccionado.fechaNacimiento
          ? new Date(empleadoSeleccionado.fechaNacimiento)
          : obtenerFechaNacimientoDesdeCurpORfc(
              empleadoSeleccionado.curp,
              empleadoSeleccionado.rfc
            );
        setValue("fechaNacimiento", fechaNacimiento);
        setValue(
          "lugarNacimiento",
          extraerEstadoDeCURP(empleadoSeleccionado.curp)
        );
        setValue("genero", mapGenero(empleadoSeleccionado.genero));
        setValue(
          "fechaIngreso",
          empleadoSeleccionado.fechaIngreso
            ? new Date(empleadoSeleccionado.fechaIngreso)
            : null
        );
        setValue(
          "seccion",
          mapPorTexto(empleadoSeleccionado.UBICACION, catalogos.Secciones)
        );
        setValue(
          "ccto",
          mapPorTexto(
            empleadoSeleccionado.SOCIO_ENCARGADO,
            catalogos.CentrosDeCostos
          )
        );
        setValue(
          "area",
          mapPorTexto(empleadoSeleccionado.PRACTICA, catalogos.Areas)
        );
        setValue(
          "nivel",
          mapPorTexto(empleadoSeleccionado.NIVEL_DE_GESTION, catalogos.Niveles)
        );
        setValue("curp", empleadoSeleccionado.curp);
        setValue("rfc", empleadoSeleccionado.rfc);
        setValue("nss", empleadoSeleccionado.imss);
        setValue("apellidoMaterno", empleadoSeleccionado.apellidoMaterno);
        setValue("direccion", empleadoSeleccionado.domicilio);
        setValue("cp", empleadoSeleccionado.cdigo_postal.toString().padStart(5, '0'));
        setValue("correoElectronico", empleadoSeleccionado.email);
        setValue("cuentaDespensa", empleadoSeleccionado.cuentaDespensa);

        const values = getValues();
        await handleCodigoPostalBlur(values.cp || 0);
      };
      obtenerNuevoNumero();
    }
  }, [empleadoSeleccionado, catalogos]);

  const getData = async () => {
    try {
      const response = await axiosPrivate.get(
        "NOM/agrupadores/select/" + selectedNomina.idNomina
      );
      setCatalogos(response.data);
      const responseEstados = await axiosPrivate.get("NOM/info-Estados");

      if (Array.isArray(responseEstados.data.Estados)) {
        setEstados(responseEstados.data.Estados);
      } else {
        console.warn(
          "La respuesta de Estados no es un arreglo:",
          responseEstados.data.Estados
        );
        setEstados([]); // fallback
      }
    } catch (error) {
      console.error("Error al obtener faltas:", error);
    }
  };
  useEffect(() => {
    if (!selectedNomina) return;
    //if (!estados) return;

    getData();
  }, [selectedNomina]);

  const opcionesGenericas = [
    { label: "Opción 1", value: "1" },
    { label: "Opción 2", value: "2" },
  ];
  const handleBack = () => {
    navigate(-1);
  };

  const handleNuevo = async () => {
    reset();
    const response = await axiosPrivate.post("/NOM/ultimo-numero", {
      nomina: selectedNomina.idNomina,
    });

    setValue("numero", Number(response.data.ultimoNumero) + 1);
    setNumeroReadOnly(true);
  };

  const handleCancelar = () => {
    reset();
  };

  function calcularAntiguedad(fechaIngresoTexto) {
    const fechaIngreso = new Date(fechaIngresoTexto);
    const hoy = new Date();
    if (isNaN(fechaIngreso)) {
      return 0;
    }
    const diferenciaMs = hoy - fechaIngreso;
    const dias = diferenciaMs / (1000 * 60 * 60 * 24);
    let antiguedad = 1;
    if (dias > 365) {
      const anti = dias / 365.0;
      antiguedad = Math.floor(anti);
    }
    return Number(antiguedad.toFixed(2));
  }

  const handleFocusSDI = async () => {
    const values = getValues();
    if (values.sdi === "" && values.pbd !== "" ) {
      try {
        const antiguedad = await calcularAntiguedad(values.fechaIngreso);
        const response = await axiosPrivate.post("/NOM/calcular-sdi", {
          numero: values.numero,
          pbd: values.pbd,
          antiguedad: antiguedad,
          gs: values.gs,
          nomina: selectedNomina.idNomina,
        });
        setValue("sdi", Number(response.data.total) + Number(values.pbd));
      } catch (error) {
        console.error("Error al calcular el SDI:", error);
      }
    }
  };

  const handleFocusSalarioMensual = async () => {
    const values = getValues();
    if (values.salarioMensual === ""  && values.pbd !== "") {
      try {

        // const antiguedad = await calcularAntiguedad(values.fechaIngreso);
        // const response = await axiosPrivate.post("/NOM/calcular-sdi", {
        //   numero: values.numero,
        //   pbd: values.pbd,
        //   antiguedad: antiguedad,
        //   gs: values.gs,
        //   nomina: selectedNomina.idNomina,
        // });
        setValue("salarioMensual", 30* Number(values.pbd));
      } catch (error) {
        console.error("Error al calcular el SDI:", error);
      }
    }
  };

  const handleFocusHorario = async () => {
    const values = getValues();

    if (catalogos.Horarios) {
      const HorarioSelected = await catalogos.Horarios.filter(
        (h) => h.numero === values.horario
      );
      setValue("turno", HorarioSelected[0]?.turno);
    }
  };

  const cp = useWatch({
    control,
    name: "cp",
  });

  useEffect(() => {
    const fetchInfo = async () => {
      if (!cp || cp.length !== 5) return;

      try {
        const response = await axiosPrivate.post("/NOM/info-cp", { cp });
        const { c_Estado, municipio, colonias } = response.data;

        setValue("estado", c_Estado);
        setValue("municipio", municipio);
        setColonias(colonias.map((c) => ({ label: c, value: c })) || []);
      } catch (error) {
        console.error("Error al buscar CP:", error);
      }
    };

    fetchInfo();
  }, [cp]); // se ejecuta cada vez que cambia "cp"
  const handleCodigoPostalBlur = async (cp) => {
    const cpStr = Number(cp);
    if (!cpStr || cpStr <= 0) return;

    try {
      const response = await axiosPrivate.post("/NOM/info-cp", { cp });
      const { c_Estado, municipio } = response.data;

      setValue("estado", c_Estado);
      setValue("municipio", municipio);
      setColonias(
        response.data.colonias.map((c) => ({ label: c, value: c })) || []
      );
    } catch (error) {
      console.error("Error al buscar CP:", error);
    }
  };
  const [paneles, setPaneles] = useState({
    A: true,
    B: false,
    C: false,
    D: false,
    E: false,
    F: false,
  });

  const toggleIndividual = (key) => {
    setPaneles((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  // Colapsar/expandir todos
  const toggleTodos = () => {
    const algunoAbierto = Object.values(paneles).some((v) => v === false);
    const nuevos = Object.fromEntries(
      Object.keys(paneles).map((k) => [k, algunoAbierto])
    );
    setPaneles(nuevos);
  };
  const tipoPago = useWatch({ control, name: "tipoPago" });

  const validateCuentaOTarjeta = (value, getValues) => {
    const cuenta = getValues("cuenta");
    const numeroTarjeta = getValues("numeroTarjeta");
    const tipoPago = getValues("tipoPago");

    if (tipoPago === 2) {
      if (!cuenta && !numeroTarjeta) {
        return "Debe capturar cuenta o tarjeta para depósito";
      }
    }
    return true;
  };
  const handleCrearHumand = async () => {
    try {
      const response = await axiosPrivate.post("/NOM//Humand/create-user", {
        empleado: empleadoCreado
        // agrega los campos requeridos por la API de Humand
      });

return;
      toast.current.show({
        severity: "success",
        summary: "Éxito",
        detail: "Empleado creado en Humand correctamente",
        life: 3000,
      });
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "No se pudo crear el empleado en Humand",
        life: 3000,
      });
      console.error("Error Humand:", error);
    }
  };

  return (
    <div className="p-4">
      <Toast ref={toast} />
      <ConfirmDialog />
      <div className="mb-3 flex justify-content-between">
        <Button
          label="Regresar"
          icon="pi pi-arrow-left"
          className="p-button-secondary"
          onClick={handleBack}
        />
        {/* <Button
          label="Agregar un registro"
          icon="pi pi-list"
          className="p-button-info"
          onClick={() => navigate("/faltas")}
        /> */}
      </div>
      <form onSubmit={handleSubmit(confirmarGuardado)} className="grid">
        {/* Columna izquierda */}
        <div className="col-2 md:col-3">
          <Panel header="Datos de ingreso" className=" ">
            <div className="p-fluid">
              <label className="text-lg font-b old text-prima ry b lock mb-3">
                {" "}
                Nomina
              </label>
              <label className="text-xl font-bold text-primary blo ck mb-3">
                {" "}
                {selectedNomina?.Nomina}
              </label>{" "}
              <br />
              <label htmlFor="numero">Numero</label>
              <Controller
                name="numero"
                control={control}
                readOnly={numeroReadOnly}
                render={({ field }) => (
                  <InputText id="numero" {...field} autoComplete="nope" />
                )}
              />
              <label htmlFor="nombre">Nombre</label>
              <Controller
                name="nombre"
                control={control}
                rules={{
                  required: " es obligatorio",
                }}
                render={({ field, fieldState }) => (
                  <>
                    {fieldState.error && (
                      <small className="p-error">
                        {fieldState.error.message}
                      </small>
                    )}
                    <InputText id="nombre" {...field} autoComplete="nope" />

                    <br />
                  </>
                )}
              />
              <label htmlFor="apellidoPaterno" className="mt-3">
                Apellido paterno
              </label>
              <Controller
                name="apellidoPaterno"
                control={control}
                rules={{
                  required: " es obligatorio",
                }}
                render={({ field, fieldState }) => (
                  <>
                    {fieldState.error && (
                      <small className="p-error">
                        {fieldState.error.message}
                      </small>
                    )}
                    <InputText
                      id="apellidoPaterno"
                      {...field}
                      autoComplete="nope"
                    />
                  </>
                )}
              />
              <label htmlFor="apellidoMaterno" className="mt-3">
                Apellido materno
              </label>
              <Controller
                name="apellidoMaterno"
                control={control}
                render={({ field }) => (
                  <InputText
                    id="apellidoMaterno"
                    {...field}
                    autoComplete="nope"
                  />
                )}
              />
              <label htmlFor="fechaNacimiento" className="mt-3">
                Fecha de nacimiento
              </label>
              <Controller
                name="fechaNacimiento"
                control={control}
                rules={{
                  required: " es obligatoria",
                  validate: (value) =>
                    value instanceof Date && !isNaN(value)
                      ? true
                      : "Fecha inválida",
                }}
                render={({ field, fieldState }) => (
                  <>
                    {fieldState.error && (
                      <small className="p-error">
                        {fieldState.error.message}
                      </small>
                    )}
                    <Calendar
                      value={field.value}
                      id="fechaNacimiento"
                      onChange={(e) => {
                        const fecha = e.value;
                        field.onChange(fecha);
                      }}
                      dateFormat="dd/mm/yy"
                      showIcon
                      {...field}
                    />
                  </>
                )}
              />
              <label htmlFor="lugarNacimiento" className="mt-3">
                Lugar de nacimiento
              </label>
              <Controller
                name="lugarNacimiento"
                control={control}
                render={({ field }) => (
                  <Dropdown
                    id="lugarNacimiento"
                    {...field}
                    value={field.value}
                    options={catalogos.Estados}
                    optionLabel="Descripcion"
                    optionValue="claveCURP"
                    placeholder="Selecciona una opción"
                  />
                )}
              />
              <label htmlFor="sexo" className="mt-3">
                Sexo
              </label>
              <Controller
                name="genero"
                control={control}
                render={({ field }) => (
                  <Dropdown
                    id="genero"
                    {...field}
                    options={catalogos.Genero}
                    optionLabel="Descripcion"
                    optionValue="numero"
                    placeholder="Selecciona una opción"
                  />
                )}
              />
              <label htmlFor="fechaIngreso" className="mt-3">
                Fecha de ingreso
              </label>
              <Controller
                name="fechaIngreso"
                control={control}
                render={({ field }) => (
                  <Calendar id="fechaIngreso" showIcon {...field} />
                )}
              />
              <label htmlFor="rfc" className="mt-3">
                RFC
              </label>
              <Controller
                name="rfc"
                control={control}
                render={({ field }) => <InputText id="rfc" {...field} />}
              />
              <label htmlFor="curp" className="mt-3">
                CURP
              </label>
              <Controller
                name="curp"
                control={control}
                rules={{
                  required: "El CURP es obligatorio",
                  minLength: {
                    value: 18,
                    message: "El CURP debe tener 18 caracteres",
                  },
                }}
                render={({ field, fieldState }) => (
                  <>
                    <InputText
                      id="curp"
                      {...field}
                      className={fieldState.invalid ? "p-invalid" : ""}
                    />
                    {fieldState.error && (
                      <small className="p-error">
                        {fieldState.error.message}
                      </small>
                    )}
                    <br />
                  </>
                )}
              />
              <label htmlFor="rfc" className="mt-3">
                NSS
              </label>
              <Controller
                name="nss"
                control={control}
                render={({ field }) => <InputText id="nss" {...field} />}
              />
              <label htmlFor="tipoContrato" className="mt-3">
                Tipo de contrato
              </label>
              <Controller
                name="tipoContrato"
                control={control}
                render={({ field }) => (
                  <Dropdown
                    id="tipoContrato"
                    {...field}
                    options={catalogos.TipoContrato}
                    optionLabel="Descripcion"
                    optionValue="c_TipoContrato"
                    placeholder="Selecciona una opción"
                  />
                )}
              />
            </div>
          </Panel>
        </div>
        {/* Columna derecha */}
        <div className="col-10 md:col-9">
          <TabView>
            <TabPanel header="Datos generales">
              <div className="grid">
                <div className="col-12 md:col-12">
                  <Button
                    type="button"
                    label="Expandir/Ocultar Todos"
                    onClick={toggleTodos}
                    className="mb-2"
                  />
                  <Panel
                    header="Datos de ingreso"
                    toggleable
                    collapsed={!paneles.A}
                    onToggle={(e) => toggleIndividual("A")}
                  >
                    <div className="grid p-fluid">
                      {/* Primera columna */}
                      <div className="col-12 md:col-4">
                        <label>Horario</label>
                        <Controller
                          name="horario"
                          control={control}
                          rules={{
                            required: " es obligatorio",
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              {fieldState.error && (
                                <small className="p-error">
                                  {fieldState.error.message}
                                </small>
                              )}
                              <Dropdown
                                id="horario"
                                {...field}
                                options={catalogos.Horarios}
                                optionLabel="Descripcion"
                                optionValue="numero"
                                placeholder="Seleccione"
                                onFocus={handleFocusHorario}
                              />
                            </>
                          )}
                        />
                        <label className="mt-3">Secciones</label>
                        <Controller
                          name="seccion"
                          control={control}
                          render={({ field }) => (
                            <Dropdown
                              id="seccion"
                              {...field}
                              options={catalogos.Secciones}
                              optionLabel="Descripcion"
                              optionValue="numero"
                              placeholder="Seleccione"
                            />
                          )}
                        />
                        <label className="mt-3">Departamento</label>
                        <Controller
                          name="departamento"
                          control={control}
                          render={({ field }) => (
                            <Dropdown
                              id="departamento"
                              {...field}
                              options={catalogos.Departamentos}
                              optionLabel="Descripcion"
                              optionValue="numero"
                              placeholder="Seleccione"
                            />
                          )}
                        />
                      </div>

                      {/* Segunda columna */}
                      <div className="col-12 md:col-4">
                        <label className="mt-3">Turno</label>
                        <Controller
                          name="turno"
                          control={control}
                          render={({ field }) => (
                            <InputText id="turno" {...field} readOnly />
                          )}
                        />
                        <label className="mt-3">Área</label>
                        <Controller
                          name="area"
                          control={control}
                          render={({ field }) => (
                            <Dropdown
                              id="area"
                              {...field}
                              options={catalogos.Areas}
                              optionLabel="Descripcion"
                              optionValue="numero"
                              placeholder="Seleccione"
                            />
                          )}
                        />
                        <label>Puesto</label>
                        <Controller
                          name="puesto"
                          control={control}
                          render={({ field }) => (
                            <Dropdown
                              id="puesto"
                              {...field}
                              options={catalogos.Puestos}
                              optionLabel="Descripcion"
                              optionValue="numero"
                              placeholder="Seleccione"
                            />
                          )}
                        />
                      </div>

                      {/* Tercera columna */}
                      <div className="col-12 md:col-4">
                        <label className="mt-3">Categoría INEGI</label>
                        <Controller
                          name="catINEGI"
                          control={control}
                          rules={{
                            required: " es obligatorio",
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              {fieldState.error && (
                                <small className="p-error">
                                  {fieldState.error.message}
                                </small>
                              )}

                              <Dropdown
                                id="catINEGI"
                                {...field}
                                options={catalogos.CatINEGI}
                                optionLabel="Descripcion"
                                optionValue="numero"
                                placeholder="Seleccione"
                              />
                            </>
                          )}
                        />
                        <label className="mt-3">Centro de costos</label>
                        <Controller
                          name="ccto"
                          control={control}
                          render={({ field }) => (
                            <Dropdown
                              id="ccto"
                              {...field}
                              options={catalogos.CentrosDeCostos}
                              optionLabel="Descripcion"
                              optionValue="numero"
                              placeholder="Seleccione"
                            />
                          )}
                        />
                        <label>Nivel</label>
                        <Controller
                          name="nivel"
                          control={control}
                          render={({ field }) => (
                            <Dropdown
                              id="nivel"
                              {...field}
                              options={catalogos.Niveles}
                              optionLabel="Descripcion"
                              optionValue="numero"
                              placeholder="Seleccione"
                            />
                          )}
                        />
                      </div>
                    </div>
                  </Panel>
                  <Panel
                    header="Datos de salarios"
                    className="mt-4"
                    toggleable
                    collapsed={!paneles.B}
                    onToggle={(e) => toggleIndividual("B")}
                  >
                    <div className="grid p-fluid">
                      <div className="col-12 md:col-3">
                        <label>Grupo de salario</label>
                        <Controller
                          name="gs"
                          control={control}
                          rules={{
                            required: " es obligatorio",
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              {fieldState.error && (
                                <small className="p-error">
                                  {fieldState.error.message}
                                </small>
                              )}
                              <Dropdown
                                id="gs"
                                {...field}
                                options={catalogos.GruposSalarios}
                                optionLabel="gs"
                                optionValue="gs"
                                placeholder="Seleccione"
                              />
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-3">
                        <label>Tipo de salario</label>
                        <Controller
                          name="tipoSalario"
                          control={control}
                          rules={{
                            required: " es obligatorio",
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              {fieldState.error && (
                                <small className="p-error">
                                  {fieldState.error.message}
                                </small>
                              )}
                              <Dropdown
                                id="tipoSalario"
                                {...field}
                                options={catalogos.TipoSalario}
                                optionLabel="Descripcion"
                                optionValue="numero"
                                placeholder="Seleccione"
                              />
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-2">
                        <label>Salario diario</label>
                        <Controller
                          name="pbd"
                          control={control}
                          rules={{
                            required: " es obligatorio",
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              {fieldState.error && (
                                <small className="p-error">
                                  {fieldState.error.message}
                                </small>
                              )}

                              <InputText id="pbd" {...field} placeholder="0" />
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-2">
                        <label>Salario integrado</label>
                        <Controller
                          name="sdi"
                          control={control}
                          rules={{
                            required: " es obligatorio",
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              {fieldState.error && (
                                <small className="p-error">
                                  {fieldState.error.message}
                                </small>
                              )}

                              <InputText
                                id="sdi"
                                {...field}
                                onFocus={handleFocusSDI}
                                placeholder="0"
                              />
                            </>
                          )}
                        />
                        {/* <label className="mt-3">Número de tarjeta</label>
                        <InputText />

                        <label className="mt-3">UMF</label>
                        <InputText /> */}
                      </div>
                      <div className="col-12 md:col-2">
                        <label>Salario mensual</label>
                        <Controller
                          name="salarioMensual"
                          control={control}
                          render={({ field }) => (
                            <InputText
                              id="salarioMensual"
                              {...field}
                              placeholder="0"
                              onFocus={handleFocusSalarioMensual}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </Panel>
                  <Panel
                    header="Información bancaria"
                    className="mt-4"
                    toggleable
                    collapsed={!paneles.C}
                    onToggle={() => toggleIndividual("C")}
                  >
                    <div className="grid p-fluid">
                      {/* Tipo de Pago */}
                      <div className="col-12 md:col-3">
                        <label>Tipo de pago</label>
                        <Controller
                          name="tipoPago"
                          control={control}
                          rules={{ required: "Tipo de pago es obligatorio" }}
                          render={({ field, fieldState }) => (
                            <>
                              {fieldState.error && (
                                <small className="p-error">
                                  {fieldState.error.message}
                                </small>
                              )}
                              <Dropdown
                                id="tipoPago"
                                {...field}
                                options={catalogos.TipoPago}
                                optionLabel="Descripcion"
                                optionValue="numero"
                                placeholder="Seleccione"
                              />
                            </>
                          )}
                        />
                      </div>

                      {/* Observa el tipo de pago */}
                      {(() => {
                        //const tipoPago = useWatch({ control, name: "tipoPago" });

                        const esEfectivo = tipoPago === 1; // Ejemplo: 1 = Efectivo
                        const esDeposito = tipoPago === 2; // Ejemplo: 2 = Depósito

                        return (
                          <>
                            {/* Banco */}
                            <div className="col-12 md:col-3">
                              <label>Banco</label>
                              <Controller
                                name="idBanco"
                                control={control}
                                rules={{
                                  validate: (value) => {
                                    if (tipoPago === 2 && !value) {
                                      return " es obligatorio para depósito";
                                    }
                                    return true;
                                  },
                                }}
                                render={({ field, fieldState }) => (
                                  <>
                                    {fieldState.error && (
                                      <small className="p-error">
                                        {fieldState.error.message}
                                      </small>
                                    )}
                                    <Dropdown
                                      id="idBanco"
                                      {...field}
                                      options={catalogos.Bancos}
                                      optionLabel="Nombre"
                                      optionValue="Clave"
                                      placeholder="Seleccione"
                                      disabled={!esDeposito}
                                    />
                                  </>
                                )}
                              />
                            </div>

                            {/* Cuenta */}
                            <div className="col-12 md:col-3">
                              <label>Cuenta</label>
                              <Controller
                                name="cuenta"
                                control={control}
                                rules={{
                                  validate: (value) =>
                                    validateCuentaOTarjeta(value, getValues),
                                }}
                                render={({ field, fieldState }) => (
                                  <>
                                    {fieldState.error && (
                                      <small className="p-error">
                                        {fieldState.error.message}
                                      </small>
                                    )}
                                    <InputText
                                      id="cuenta"
                                      {...field}
                                      disabled={!esDeposito}
                                      placeholder="0"
                                    />
                                  </>
                                )}
                              />
                            </div>

                            {/* Tarjeta */}
                            <div className="col-12 md:col-3">
                              <label>Tarjeta</label>
                              <Controller
                                name="numeroTarjeta"
                                control={control}
                                rules={{
                                  validate: (value) =>
                                    validateCuentaOTarjeta(value, getValues),
                                }}
                                render={({ field, fieldState }) => (
                                  <>
                                    {fieldState.error && (
                                      <small className="p-error">
                                        {fieldState.error.message}
                                      </small>
                                    )}
                                    <InputText
                                      id="numeroTarjeta"
                                      {...field}
                                      disabled={!esDeposito}
                                      placeholder="0"
                                    />
                                  </>
                                )}
                              />
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </Panel>
                  <Panel
                    header="Cuenta despensa"
                    className="mt-4"
                    toggleable
                    collapsed={!paneles.D}
                    onToggle={(e) => toggleIndividual("D")}
                  >
                    <div className="grid p-fluid">
                      <div className="col-12 md:col-3">
                        <label>Servicio</label>
                        <Controller
                          name="servicioDespensa"
                          control={control}
                          rules={{
                            required: " es obligatorio",
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              {fieldState.error && (
                                <small className="p-error">
                                  {fieldState.error.message}
                                </small>
                              )}
                              <Dropdown
                                id="servicioDespensa"
                                {...field}
                                options={catalogos.Despensas}
                                optionLabel="nombre"
                                optionValue="nombre"
                                placeholder="Seleccione"
                              />
                            </>
                          )}
                        />
                      </div>

                      <div className="col-12 md:col-3">
                        <label>Numero de cuenta</label>
                        <Controller
                          name="cuentaDespensa"
                          control={control}
                          render={({ field }) => (
                            <InputText
                              id="cuentaDespensa"
                              {...field}
                              placeholder="0"
                            />
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-3">
                        <label>Numero de tarjeta</label>
                        <Controller
                          name="tarjetaDespensa"
                          control={control}
                          render={({ field }) => (
                            <InputText
                              id="tarjetaDespensa"
                              {...field}
                              placeholder="0"
                            />
                          )}
                        />
                      </div>
                    </div>
                  </Panel>
                  <Panel
                    header="Domicilio"
                    className="mt-4"
                    toggleable
                    collapsed={!paneles.E}
                    onToggle={(e) => toggleIndividual("E")}
                  >
                    <div className="grid p-fluid">
                      <div className="col-12 md:col-5">
                        <label htmlFor="direccion">Dirección</label>
                        <Controller
                          name="direccion"
                          control={control}
                          render={({ field }) => (
                            <InputText id="direccion" {...field} />
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-1">
                        <label htmlFor="numCasa">Número</label>
                        <Controller
                          name="numCasa"
                          control={control}
                          render={({ field }) => (
                            <InputText id="numCasa" {...field} />
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-3">
                        <label htmlFor="colonia">Colonia</label>
                        <Controller
                          name="colonia"
                          control={control}
                          render={({ field }) => (
                            <Dropdown
                              id="colonia"
                              {...field}
                              options={Array.isArray(colonias) ? colonias : []}
                              onChange={(e) => field.onChange(e.value)}
                              editable
                            />
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-3">
                        <label htmlFor="ciudad">Ciudad</label>
                        <Controller
                          name="ciudad"
                          control={control}
                          render={({ field }) => (
                            <InputText id="ciudad" {...field} />
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-3">
                        <label htmlFor="cp">CP</label>
                        <Controller
                          name="cp"
                          control={control}
                          rules={{
                            required: " es obligatorio",
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              {fieldState.error && (
                                <small className="p-error">
                                  {fieldState.error.message}
                                </small>
                              )}
                              <InputText
                                id="cp"
                                {...field}
                                autoComplete="nope"
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-3">
                        <label htmlFor="municipio">Municipio</label>
                        <Controller
                          name="municipio"
                          control={control}
                          render={({ field }) => (
                            <InputText id="municipio" {...field} />
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-3">
                        <label htmlFor="estado">Estado</label>
                        <Controller
                          name="estado"
                          control={control}
                          render={({ field }) => (
                            <Dropdown
                              id="estado"
                              {...field}
                              value={field.value}
                              options={Array.isArray(estados) ? estados : []}
                              optionLabel="nombreEstado"
                              optionValue="c_Estado"
                              placeholder="Selecciona una opción"
                            />
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-3"></div>
                      <div className="col-12 md:col-3">
                        <label htmlFor="telefono">Teléfono</label>
                        <Controller
                          name="telefono"
                          control={control}
                          render={({ field }) => (
                            <InputText id="telefono" {...field} />
                          )}
                        />
                      </div>
                      <div className="col-12 md:col-4">
                        <label htmlFor="correoElectronico">
                          Correo electrónico
                        </label>
                        <Controller
                          name="correoElectronico"
                          control={control}
                          render={({ field }) => (
                            <InputText id="correoElectronico" {...field} />
                          )}
                        />
                      </div>
                    </div>
                  </Panel>
                  {/* <Panel
                    header="Informacion adicional"
                    className="mt-4"
                    toggleable
                    collapsed={!paneles.F}
                    onToggle={(e) => toggleIndividual("F")}
                  >
                    <div className="grid p-fluid">
                      <div className="col-12 mt-4">
                        <div className="card">
                          <div className="grid">
                            <div className="col-12 md:col-2">
                              <label htmlFor="municipioNacimiento">
                                Mpio de nacimiento
                              </label>
                              <Dropdown
                                id="municipioNacimiento"
                                options={opcionesGenericas}
                                placeholder="Selecciona una opción"
                              />
                            </div>
                            <div className="col-12 md:col-2">
                              <label htmlFor="escolaridad">Escolaridad</label>
                              <Dropdown
                                id="escolaridad"
                                options={opcionesGenericas}
                                placeholder="Selecciona una opción"
                              />
                            </div>
                            <div className="col-12 md:col-2">
                              <label htmlFor="estadoCivil">Estado civil</label>
                              <Dropdown
                                id="estadoCivil"
                                options={opcionesGenericas}
                                placeholder="Selecciona una opción"
                              />
                            </div>
                            <div className="col-12 md:col-2">
                              <label htmlFor="religion">Religión</label>
                              <InputText id="religion" />
                            </div>
                            <div className="col-12 md:col-2">
                              <label htmlFor="vivienda">Vivienda</label>
                              <Dropdown
                                id="vivienda"
                                options={opcionesGenericas}
                                placeholder="Selecciona una opción"
                              />
                            </div>
                            <div className="col-12 md:col-2">
                              <label htmlFor="umf">UMF</label>
                              <Controller
                                name="umf"
                                control={control}
                                render={({ field }) => (
                                  <InputText id="umf" {...field} />
                                )}
                              />
                            </div>
                          </div>

                          <div className="grid mt-3">
                            <div className="col-12 md:col-2">
                              <label htmlFor="gaveta">Gaveta</label>
                              <InputText id="gaveta" />
                            </div>
                            <div className="col-12 md:col-2">
                              <label htmlFor="tipoSangre">Tipo de sangre</label>
                              <Dropdown
                                id="tipoSangre"
                                options={opcionesGenericas}
                                placeholder="Selecciona una opción"
                              />
                            </div>
                            <div className="col-12 md:col-2">
                              <label htmlFor="tallaPantalon">
                                Talla de pantalón
                              </label>
                              <InputText id="tallaPantalon" />
                            </div>
                            <div className="col-12 md:col-2">
                              <label htmlFor="tallaCamisa">
                                Talla de camisa
                              </label>
                              <InputText id="tallaCamisa" />
                            </div>
                            <div className="col-12 md:col-2">
                              <label htmlFor="tallaZapato">
                                Talla de zapato
                              </label>
                              <InputText id="tallaZapato" />
                            </div>
                            <div className="col-12 md:col-2">
                              <label htmlFor="folio">Folio</label>
                              <InputText id="folio" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Panel> */}
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>

        <div className="flex gap-2">
          <Button
            label="Nuevo"
            type="button"
            icon="pi pi-plus"
            severity="primary"
            onClick={handleNuevo}
          />
          <Button
            label="Guardar"
            icon="pi pi-save"
            severity="success"
            type="submit"
            //onClick={onSubmit}
          />
          {true && (
            <Button
              label="Crear en Humand"
              icon="pi pi-cloud-upload"
              className="p-button-success"
              onClick={handleCrearHumand}
              type="button"
              disabled="true"            />
          )}

          <Button
            label="Cancelar"
            icon="pi pi-times"
            severity="secondary"
            type="button"
            onClick={handleCancelar}
          />
        </div>
      </form>

      {/* <Toolbar className="mb-4" right={rightToolbarTemplate} /> */}
    </div>
  );
}
